import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import './Services.css';

const Services = () => {
  const { t, isMarathi } = useLanguage();

  const pageHeaderData = {
    title: {
      marathi: 'सेवा',
      english: 'Services'
    },
    subtitle: {
      marathi: 'महाराष्ट्र कामगार कल्याण मंडळाच्या सेवा',
      english: 'Services of Maharashtra Labour Welfare Board'
    }
  };

  return (
    <div className="services-container">
      <PageHeader 
        title={pageHeaderData.title}
        subtitle={pageHeaderData.subtitle}
      />

      <div className="services-content">
        <section className="services-section">
          <h2 className="section-title">
            {isMarathi() ? 'सेवा' : 'Services'}
          </h2>
          <div className="section-content">
            <div className="section-text">
              {isMarathi() ? (
                <div>
                  <p>{t('comingSoon')}</p>
                </div>
              ) : (
                <div>
                  <p>{t('comingSoon')}</p>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Services;

